<template>
  <van-overlay :show="loading">
    <div class="wrapper">
      <div class="block" style="text-align: center;">
        <div v-for="tip in tips" :key="tip.key">
          {{ tip.name }}
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Init',
  props: {
    initStates: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['tips'])
  },
  created() {
    this.loading = true
    this.init()
      .then(() => {
        this.success('初始化系统数据成功')
        this.loading = false
        this.$store.dispatch('tip/clear')
        this.$emit('after-init')
      })
      .catch(_ => {
        this.alert('初始化系统数据失败')
        this.loading = false
        this.$store.dispatch('tip/clear')
        this.$emit('error')
      })
  },
  methods: {
    init() {
      return new Promise(async(resolve, reject) => {
        try {
          for (let i = 0, j = this.initStates.length; i < j; i++) {
            const initObj = this.initStates[i]
            await this.$store.dispatch(initObj.key, (initObj.params || {}), { root: true })
          }
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
</script>

<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 100%;
    color: #13C2C2;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/init.vue